<span class="user-display" *ngIf="user; else unassigned">{{ user.name }}</span>

<ng-template #unassigned>
  <span class="unassigned">Unassigned</span>
</ng-template>
